// The API answers a 422 two ways: a field map under `errors`, or a query-layer refusal with
// `errors: null` and the reason in `message`. Laravel's `message` for a field map is the generic
// "The given data was invalid.", so the field message is the one worth showing.
//
// Only messages the API actually sent are shown. Axios fills `error.message` with its own strings
// ("Network Error", "timeout of 0ms exceeded") when a request never reached the API, and the
// caller's own copy reads better than any of them.
export const apiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const body = error?.response?.data;
  if (typeof body === 'string') return body;
  const fieldMessage = Object.values(body?.errors ?? {}).flat().find(Boolean);
  return fieldMessage || body?.message || fallback;
};

export default apiErrorMessage;
